import { Phone, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const CTASection = ({ onBookClick }) => {
  return (
    <section
      id="cta"
      className="cta-section section-padding"
      data-testid="cta-section"
    >
      <div className="container-custom text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
          Ready for a Cleaner Home?
        </h2>
        <p className="text-xl text-sky-100 max-w-2xl mx-auto mb-10">
          Schedule your professional house cleaning service today and experience 
          the difference. Flexible scheduling, transparent pricing, reliable service.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            onClick={onBookClick}
            className="bg-white text-sky-700 hover:bg-sky-50 text-lg rounded-full px-8 py-6 font-semibold shadow-lg hover:shadow-xl transition-all duration-300 inline-flex items-center gap-2"
            data-testid="cta-book-btn"
          >
            Book Cleaning Service
            <ArrowRight className="w-5 h-5" />
          </Button>
          <a
            href="tel:+18884532345"
            className="inline-flex items-center justify-center gap-2 bg-sky-700 hover:bg-sky-800 text-white text-lg rounded-full px-8 py-6 font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
            data-testid="cta-call-btn"
          >
            <Phone className="w-5 h-5" />
            Call (888) 453-2345
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
